import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class AppAlertComponent extends Vue {
  @Prop({ default: false })
  public show!: boolean | number;
  @Prop({ default: false })
  public dismissible!: boolean;
  @Prop()
  public variant!: string;
  @Prop()
  public header!: string;
  @Prop()
  public icon!: string | string[];

  public get headerIcon(): string | string[] | undefined {
    if (this.icon) {
      return this.icon;
    }

    switch (this.variant) {
      case 'danger':
        return 'exclamation-circle';
      case 'warning':
        return 'exclamation-triangle';
      case 'success':
        return ['far', 'check-circle'];
    }

    return undefined;
  }

  public proxyEvent(event: Event) {
    this.$log.debug(event);
    const type = typeof event === 'string' ? event : event.type;
    this.$emit(type, event);
  }
}
